import { TranslateFunc } from "../../utils/translation.utils";

export const getActiveStatusLabel = (active: Date | null | undefined, t: TranslateFunc) => {
  return active == null ? t("general.inactive") : t("general.active");
};
